import React, { useEffect } from 'react';
import FAQSection from '../components/FAQSection';

const FAQ = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="page-hero">
        <div className="container page-hero__content">
          <h1 className="page-hero__title">FAQ</h1>
          <div className="breadcrumb">
            <a href="/">Home</a> <span>/</span> FAQ
          </div>
        </div>
      </section>

      <FAQSection />
    </>
  );
};

export default FAQ;
